export const formatPhoneRemove = (phone: string): string => {
	// +1 (123) 445-5667 -> +11234455667
	if (!phone) return phone;
	return phone
		.replace(/\s/g, '')
		.replaceAll('-', '')
		.replaceAll('(', '')
		.replaceAll(')', '');
};

export const formatPhone = (phone: string): string => {
	if (!phone) return '';
	const formattedPhone = phone
		.replace(/\s/g, '')
		.replaceAll('+1', '')
		.replaceAll('-', '')
		.replaceAll('(', '')
		.replaceAll(')', '');
	let formattedValue = '';
	if (formattedPhone.length === 10) {
		formattedValue = formattedPhone.replace(
			/([0-9]{3})([0-9]{3})([0-9]{4})/g,
			'+1 ($1) $2-$3'
		);
	}
	return formattedValue; // +11234455667 -> +1 (123) 445-5667
};
